import Text from '@components/Text/Text'
import { TextTag } from '@enums/textTag'
import { VelvetSDK } from 'sdk'

interface SearchNoResultProps {
  value: string
}

const SearchNoResultLabels = ({ value }: SearchNoResultProps) => {
  const V = VelvetSDK.Vocabulary.vocabulary

  return (
    <div className="search-text-no-results">
      <Text tag={TextTag.P}>{V.searchNoResultsTitle}</Text>
      <div className="second-line">
        <Text tag={TextTag.P}>
          {V.searchPageNoMatchLabel} {value}
        </Text>
      </div>
    </div>
  )
}

export default SearchNoResultLabels
